import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBrainStereoVision = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M33.32 39.566V32.89a14.2 14.2 0 0 0 3.463-4.733 13.7 13.7 0 0 0 1.22-5.715q.001-5.846-4.084-9.938-4.085-4.09-9.92-4.091-4.862 0-8.616 2.869-3.754 2.868-4.899 7.443l-2.148 8.516q-.137.54.19.964.329.423.904.422h3.672v5.567q0 .954.655 1.6.654.645 1.59.646h4.005v3.125zm-5.445-10.957q-1.61 0-2.734-1.122L18.938 21.3q-1.11-1.125-1.11-2.73t1.113-2.744q1.13-1.123 2.745-1.123 1.614 0 2.74 1.109 1.432-.478 2.82-.22a4.4 4.4 0 0 1 2.361 1.233 4.43 4.43 0 0 1 1.24 2.365q.262 1.389-.245 2.817 1.132 1.128 1.132 2.742t-1.125 2.737-2.734 1.123" })
});
export default SvgBrainStereoVision;
